<template>
  <!-- 解决方案页面 -->
  <div>
    <!-- PC端 -->
    <div class="solution" v-if="webFlag">
      <!-- 头部 -->
      <head-nav :selectedId="1"></head-nav>
      <img src="@/assets/images/banner05.png" alt="" style="width: 100%" />
      <el-container>
        <el-aside width="100%">
          <title-com :name="'解决方案'" :letter="'SOLUTION'"></title-com>
          <!-- <div  class="row" style="display:flex; justify-content: space-between;flex-wrap:wrap"> -->
          <el-row style="width: 100%">
            <el-col :span="8">
              <el-menu default-active="/solution" class="el-menu-demo">
                <el-menu-item
                  v-for="(item, i) in solutionList"
                  :key="i"
                  @click="eventHandle(i)"
                  :class="{ actived: is_active == i }"
                >
                  <ul>
                    <li>
                      <span class="point"></span>
                      <span>{{ item.text }}</span>
                      <img
                        :src="is_active == i ? item.url : item.path"
                        alt=""
                        class="icon"
                      />
                    </li>
                  </ul>
                </el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="14">
              <div>
                <special-project v-if="is_active == 0"></special-project>
                <emergency v-if="is_active == 1"></emergency>
                <everyday v-if="is_active == 2"></everyday>
                <educationalWisdom v-if="is_active == 3"></educationalWisdom>
                <billboard v-if="is_active == 4"></billboard>
                <product v-if="is_active == 5"></product>
              </div>
            </el-col>
          </el-row>

          <!-- </div> -->
        </el-aside>
      </el-container>
      <!-- 尾部 -->
      <footer-com />
    </div>
    <!-- 移动端 -->
    <div v-if="mobilPhoneFlag" class="solution">
      <!-- 头部 -->
      <mobileHead></mobileHead>
      <img
        src="@/assets/images/banner05.png"
        alt=""
        class="banner"
        style="width: 100%; margin-top: 44px"
      />
      <el-container>
        <div class="sulotion-menu mg">
          <div
            class="item"
            v-for="(item, i) in solutionList"
            :key="i"
            @click="eventHandle(i)"
            :class="{ actived: is_active == i }"
          >
          <img :src="is_active==i?item.path:item.gray" alt="" />
            <p>{{item.text}}</p>
          </div>
        </div>
        <div style="background: #fff; padding: 40px 0 72px">
          <special-project v-if="is_active == 0" class="mg"></special-project>
          <emergency v-if="is_active == 1" class="mg"></emergency>
          <everyday v-if="is_active == 2" class="mg"></everyday>
          <educationalWisdom
            v-if="is_active == 3"
            class="mg"
          ></educationalWisdom>
          <billboard v-if="is_active == 4" class="mg"></billboard>
          <product v-if="is_active == 5" class="mg"></product>
        </div>
      </el-container>
      <mobile-footer></mobile-footer>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/header.vue";
import footerCom from "@/components/footer.vue";
import titleCom from "@/components/title.vue";
import specialProject from "@/components/solution/specialProject.vue";
import emergency from "@/components/solution/emergency.vue";
import everyday from "@/components/solution/everyday.vue";
import educationalWisdom from "@/components/solution/educationalWisdom.vue";
import billboard from "@/components/solution/billboard.vue";
import product from "@/components/solution/product.vue";

// 移动端组件
import mobileHead from "@/components/publicCom/mobileHead.vue";
import mobileFooter from "@/components/publicCom/mobileFooter.vue";
export default {
  components: {
    headNav,
    footerCom,
    titleCom,
    specialProject,
    emergency,
    everyday,
    billboard,
    educationalWisdom,
    product,
    mobileHead,
    mobileFooter,
  },
  data() {
    return {
      solutionList: [
        {
          id: 0,
          name: "introduce",
          text: "安全专项管理",
          url: require("../assets/images/icon_about_introduce01(1).png"),
          path: require("../assets/images/icon_about_introduce02(1).png"),
          gray: require("../assets/images/icon_about_introduce03(1).png"),
        },
        {
          id: 1,
          name: "culture",
          text: "应急管理",
          url: require("../assets/images/icon_about_culture01(1).png"),
          path: require("../assets/images/icon_about_culture02(1).png"),
          gray: require("../assets/images/icon_about_culture03(1).png"),
        },
        {
          id: 2,
          name: "honor",
          text: "日常安全管理",
          url: require("../assets/images/icon_about_daily01.png"),
          path: require("../assets/images/icon_about_daily02.png"),
          gray: require("../assets/images/icon_about_daily03.png"),
        },
        {
          id: 3,
          name: "honor",
          text: "智慧教务",
          url: require("../assets/images/icon_obout_interaction01.png"),
          path: require("../assets/images/icon_obout_interaction02.png"),
          gray: require("../assets/images/icon_obout_interaction03.png"),
        },
        {
          id: 4,
          name: "honor",
          text: "信息看板",
          url: require("../assets/images/icon_about_platform01.png"),
          path: require("../assets/images/icon_about_platform02.png"),
          gray: require("../assets/images/icon_about_platform03.png"),
        },
        {
          id: 5,
          name: "honor",
          text: "前端产品介绍",
          url: require("../assets/images/icon_about_product01.png"),
          path: require("../assets/images/icon_about_product02.png"),
          gray: require("../assets/images/icon_about_product03.png"),
        },
      ],
      is_active: 0,
      webFlag: true,
      mobilPhoneFlag: false,
    };
  },
  created() {},
  mounted() {
    this.getScreenWidth();
  },
  methods: {
    getScreenWidth() {
      console.log(document.body.offsetWidth, window.screen.availWidth);
      if (window.screen.availWidth <= 1366) {
        this.webFlag = false;
        this.mobilPhoneFlag = true;
        console.log(window.screen.availWidth);
      }
    },
    //PC端跳转
    eventHandle(index) {
      this.is_active = index;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1367px) {
  .solution {
    width: 100%;
    .el-container {
      margin: 40px;
      .el-menu {
        width: 80%;
        margin: 0 auto;
        .el-menu-item {
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          height: 80px;
          line-height: 80px;
          color: #454545;
          padding: 0;
          ul > li {
            list-style-type: square;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0;
          }
        }
        .actived {
          width: 100%;
          color: #ffffff;
          background: #3660d9;
        }
        .icon {
          width: 38px;
          height: 38px;
        }
        .point {
          width: 5px;
          height: 5px;
          background: #e0e0e0;
        }
      }
      .summarize {
        padding: 60px;
        background: #ffffff;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
        border-radius: 14px;
        margin-bottom: 100px;
        div {
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #454545;
          line-height: 36px;
          text-align: left;
          text-indent: 2em;
          margin-bottom: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .solution {
    width: 100vw;
    .el-container {
      width: 100%;
      display: inline-block;
      .mg {
        margin: 0 40px;
      }
      .sulotion-menu {
        width: calc(100% - 80px);
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 30px 0 0;
        .item {
          width: 30%;
          height: 108px;
          background: #ffffff;
          box-shadow: 3px 4px 5px 0px rgba(10, 54, 115, 0.05);
          border-radius: 5px;
          text-align: center;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #454545;
          margin: 0px 0 30px;
          img {
            margin-top: 16px;
            width: 38px;
            height: 38px;
          }
        }
        .item:hover {
          color: #3660d9;
        }
      }
      .summarize {
        padding: 60px;
        background: #ffffff;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
        border-radius: 14px;
        margin-bottom: 100px;
        div {
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #454545;
          line-height: 36px;
          text-align: left;
          text-indent: 2em;
          margin-bottom: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/solution.vue